<template>
  <a-card title="Setting Product" :loading="item.loading">
    <a-row>
      <a-col>
        <a-form-model ref="setting"
                      :label-col="{ span: 4 }"
                      :wrapper-col="{ span: 12 }"
                      :model="form">
          <a-form-model-item label="Product Group">
            <group-select @change="onProductGroupChange" :value="item.product.group.name">
            </group-select>
          </a-form-model-item>
          <a-form-model-item label="Code" ref="code">
            <a-input placeholder="Code" v-model="form.code">
            </a-input>
          </a-form-model-item>
          <a-form-item label="Name" ref="name">
            <a-input placeholder="Name" v-model="form.name">
            </a-input>
          </a-form-item>
          <a-form-model-item label="Description" ref="description">
            <a-input type="textarea" placeholder="Description" v-model="form.description">
            </a-input>
          </a-form-model-item>
          <a-form-model-item label="Order To" ref="order">
            <a-input type="number" placeholder="Order To" v-model="form.order">
            </a-input>
          </a-form-model-item>
          <a-form-model-item label="Tipe Produk" ref="is_postpaid">
            <a-checkbox v-model="form.is_postpaid">
              Postpaid
            </a-checkbox>
          </a-form-model-item>
          <a-form-model-item label="Denomination" ref="denomination" v-if="! form.is_postpaid">
            <a-input type="number" placeholder="Denomination" v-model="form.denomination">
            </a-input>
          </a-form-model-item>
          <a-form-model-item label="Price Scheme" ref="price_scheme">
            <a-select v-model="form.price_scheme"
                      placeholder="Select Price Scheme">
              <a-select-option v-for="scheme in clientSchemes" :key="scheme" :value="scheme">
                {{ scheme }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Price" ref="price" v-if="form.price_scheme === schemes.PRICE_SCHEME_DEFAULT">
            <a-input type="number" placeholder="Price" v-model="form.price">
            </a-input>
          </a-form-model-item>

          <a-form-model-item label="Admin Fee" v-if="form.price_scheme === schemes.PRICE_SCHEME_ADMIN_FEE">
            <a-input type="number" placeholder="admin_fee" v-model="form.admin_fee">
            </a-input>
          </a-form-model-item>

          <a-form-model-item label="Share Fee" v-if="form.price_scheme === schemes.PRICE_SCHEME_ADMIN_FEE || form.price_scheme === schemes.PRICE_SCHEME_COMMISSION">
            <a-input type="number" placeholder="Share Fee" v-model="form.share_fee">
            </a-input>
          </a-form-model-item>

          <a-form-model-item label="Profit Threshold" ref="profit_threshold">
            <a-input type="number" placeholder="Profit Threshold" v-model="form.profit_threshold">
            </a-input>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ offset: 4 }">
            <a-button type="primary" html-type="submit" class="login-form-button" @click="save" :loading="submitting">
              Save
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import rules from './product-setting-rules'
import {schemes, clientSchemes} from "../../../config/pricing"

export default {
  name: "product-setting",
  computed: {
    clientSchemes
  },
  props: {
    product: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      schemes,
      rules,
      item: {
        loading: false,
        product: {}
      },
      submitting: false,
      form: {
        group_id: 0,
        code: '',
        name: '',
        description: '',
        is_postpaid: '',
        denomination: 0,
        price_scheme: '',
        price: 0,
        admin_fee: 0,
        share_fee: 0,
        profit_threshold: 0,
        order: null
      }
    }
  },
  watch: {
    'item.product': function (value) {
      this.form.group_id = value.group.id
      this.form.code = value.code
      this.form.name = value.name
      this.form.description = value.description
      this.form.is_postpaid = value.is_postpaid
      this.form.denomination = value.denomination
      this.form.price_scheme = value.price_scheme
      this.form.price = value.price
      this.form.admin_fee = value.admin_fee
      this.form.share_fee = value.share_fee
      this.form.profit_threshold = value.profit_threshold
      this.form.order = value.order
    },
    'form.price_scheme': function (value) {
      if (value === schemes.PRICE_SCHEME_DEFAULT) {
        this.rules.price = [
          {rules: {required: true}}
        ]
      } else if (value === schemes.PRICE_SCHEME_ADMIN_FEE) {
        this.rules.admin_fee = [
          {rules: {required: true}}
        ]

        this.rules.share_fee = [
          {rules: {required: true}}
        ]
      } else if (value === schemes.PRICE_SCHEME_COMMISSION) {
        this.rules.share_fee = [
          {rules: {required: true}}
        ]
      }
    }
  },
  created() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product.show', {
        product_hash: this.product
      }), {
        params: {
          with: 'group'
        }
      }).then(res => {
        (this.item.product = res.data)
      }).catch(err => this.handleXhrError(err))
        .finally(() => (this.item.loading = false))
    },
    onProductGroupChange(data) {
      this.form.group_id = data.id
    },
    save() {
      this.$refs.setting.validate(valid => {
        if (valid) {
          this.updateProduct()
        } else {

        }
      })
    },
    updateProduct() {
      this.submitting = true
      this.$http.put(this.routeUri('hyperion.product.update', {
        product_hash: this.product
      }), this.form)
        .then(res => this.handleSuccessResponse(res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.submitting = false))
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "You will be redirected in a few moment."
      })

      setTimeout(() => window.location.href = data.redirect, 3000)
    }
  }
}
</script>
